import { Faq } from '@owl-nest/api-client/latest'
import { ACTION_TYPE, FaqAction } from '../actions/faq'
import { Status } from '@owl-nest/redux-wrapper'

export type State = {
  faq: Faq[]
  next: string | null
  status: {
    load: Status
    creation: Status
  }
}

export const initialState: State = {
  faq: [],
  next: null,
  status: {
    load: Status.PRISTINE,
    creation: Status.PRISTINE,
  },
}

export function reducer(state = initialState, action: FaqAction): State {
  switch (action.type) {
    case ACTION_TYPE.LOAD_FAQ_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          load: Status.PENDING,
        },
      }
    }
    case ACTION_TYPE.LOAD_FAQ_FAILURE: {
      return {
        ...state,
        faq: [],
        next: null,
        status: {
          ...state.status,
          load: Status.FAILURE,
        },
      }
    }
    case ACTION_TYPE.LOAD_FAQ_SUCCESS: {
      if (action.success.forceClean) {
        return {
          ...state,
          faq: action.success.faq,
          next: action.success.meta.next,
          status: {
            ...state.status,
            load: Status.SUCCESS,
          },
        }
      }
      return {
        ...state,
        faq: state.faq.concat(action.success.faq),
        next: action.success.meta.next,
        status: {
          ...state.status,
          load: Status.SUCCESS,
        },
      }
    }
    case ACTION_TYPE.CREATE_FAQ_REQUEST: {
      return {
        ...state,
        status: {
          ...state.status,
          creation: Status.PENDING,
        },
      }
    }
    case ACTION_TYPE.CREATE_FAQ_SUCCESS: {
      return {
        ...state,
        status: {
          ...state.status,
          creation: Status.SUCCESS,
        },
      }
    }
    case ACTION_TYPE.CREATE_FAQ_FAILURE: {
      return {
        ...state,
        status: {
          ...state.status,
          creation: Status.FAILURE,
        },
      }
    }
    default:
      return state
  }
}
